import { render } from "./FileExplorer.vue?vue&type=template&id=4b06ae25&scoped=true"
import script from "./FileExplorer.vue?vue&type=script&lang=js"
export * from "./FileExplorer.vue?vue&type=script&lang=js"

import "./FileExplorer.vue?vue&type=style&index=0&id=4b06ae25&scoped=true&lang=scss"

import exportComponent from "/tmp/f3315f41-3418-4066-838e-b0c15008937b/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b06ae25"]])

export default __exports__